import script from "./multi-temporal.vue?vue&type=script&setup=true&lang=js"
export * from "./multi-temporal.vue?vue&type=script&setup=true&lang=js"

import "./multi-temporal.vue?vue&type=style&index=0&id=1da5a812&lang=css"

const __exports__ = script;

export default __exports__